import { render, staticRenderFns } from "./Hmis.vue?vue&type=template&id=2d9ea80c"
import script from "./Hmis.vue?vue&type=script&lang=js"
export * from "./Hmis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports